/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Pro_Feature_3Inputs */

const en_settings_pro_feature_3 = /** @type {(inputs: Settings_Pro_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full analytics + insights`)
};

const de_settings_pro_feature_3 = /** @type {(inputs: Settings_Pro_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vollständige Analysen + Einblicke`)
};

const fr_settings_pro_feature_3 = /** @type {(inputs: Settings_Pro_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyses complètes + insights`)
};

const es_settings_pro_feature_3 = /** @type {(inputs: Settings_Pro_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Análisis completos + información`)
};

const it_settings_pro_feature_3 = /** @type {(inputs: Settings_Pro_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analisi complete + approfondimenti`)
};

const nl_settings_pro_feature_3 = /** @type {(inputs: Settings_Pro_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Volledige analyses + inzichten`)
};

const pl_settings_pro_feature_3 = /** @type {(inputs: Settings_Pro_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pełne analizy + wglądy`)
};

const fi_settings_pro_feature_3 = /** @type {(inputs: Settings_Pro_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Täydellinen analytiikka + näkymät`)
};

const da_settings_pro_feature_3 = /** @type {(inputs: Settings_Pro_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fulde analyser + indsigt`)
};

const sv_settings_pro_feature_3 = /** @type {(inputs: Settings_Pro_Feature_3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fullständig analys + insikter`)
};

/**
* | output |
* | --- |
* | "Full analytics + insights" |
*
* @param {Settings_Pro_Feature_3Inputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }} options
* @returns {LocalizedString}
*/
export const settings_pro_feature_3 = /** @type {((inputs?: Settings_Pro_Feature_3Inputs, options?: { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Pro_Feature_3Inputs, { locale?: "en" | "de" | "fr" | "es" | "it" | "nl" | "pl" | "fi" | "da" | "sv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return de_settings_pro_feature_3(inputs)
	if (locale === "fr") return fr_settings_pro_feature_3(inputs)
	if (locale === "es") return es_settings_pro_feature_3(inputs)
	if (locale === "it") return it_settings_pro_feature_3(inputs)
	if (locale === "nl") return nl_settings_pro_feature_3(inputs)
	if (locale === "pl") return pl_settings_pro_feature_3(inputs)
	if (locale === "fi") return fi_settings_pro_feature_3(inputs)
	if (locale === "da") return da_settings_pro_feature_3(inputs)
	if (locale === "sv") return sv_settings_pro_feature_3(inputs)
	return en_settings_pro_feature_3(inputs)
});